import * as React from "react";
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

export default class ConfirmationModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { proxySource } = this.props;
        logUI(`MBHWeb.UI.${proxySource}.ConfirmationModal.ComponentDidMount`, new Date(), Tools.getURLPath());
    }
    

    render() {
        const { isOpen, message, onConfirmed, enableCloseButton } = this.props;
        
        return (
            <Modal className="verify-modal" isOpen={isOpen} toggle={() => onConfirmed()} centered>
                {
                    enableCloseButton && <ModalHeader toggle={enableCloseButton} />
                }
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <p>{message}</p>{
                                !enableCloseButton && 
                                <div className="row link-container">
                                    <div className="col-6 link-left" onClick={() => onConfirmed(true)}>YES</div>
                                    <div className="col-6 link-right" onClick={() => onConfirmed()}>NO</div>
                                </div>
                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}